// extracted by mini-css-extract-plugin
export default {"bubble":"FXfJn","content":"_8eTSx","triangleWrapper":"sSfgf","triangle":"x4AlO"};